import React from 'react';
import PropTypes from 'prop-types';
import SpinnerContainer from '../SpinnerContainer/SpinnerContainer';
import { AbsenceDots } from './AbsenceDots';
import { AbsenceSummaryBlock } from './AbsenceSummaryBlock';

export const AbsencesSummary = ({ absencesSummary }) => {
  if (!absencesSummary.intraYearlyHolidays) {
    return (
      <SpinnerContainer className="absences-spinner-container" />
    );
  }

  return (
    <div className="absence-summary-container">
      <p className="absence-summary-row">
        <div>
          <span className={absencesSummary.intraYearlyHolidays - absencesSummary.intraApprovedHolidays - absencesSummary.intraApprovedSpecialHolidays > 0
            ? 'absence-row-text-green'
            : 'absence-row-text-gray'}
          >
            {' '}
            {absencesSummary.intraYearlyHolidays - absencesSummary.intraApprovedHolidays - absencesSummary.intraApprovedSpecialHolidays}
            {' '}
            day(s)
          </span>
          {' '}
          remaining
          {' '}
          <span className="absence-row-text-gray">
          of
            {' '}
            {absencesSummary.intraYearlyHolidays}
            {' '}
          days
          </span>
        </div>
        <AbsenceDots
          greenCount={absencesSummary.intraYearlyHolidays - absencesSummary.intraApprovedHolidays - absencesSummary.intraApprovedSpecialHolidays}
          grayDotCount={absencesSummary.intraApprovedHolidays + absencesSummary.intraApprovedSpecialHolidays}
        />
      </p>

      <AbsenceSummaryBlock
        takenDaysCount={absencesSummary.absenceStats.q1}
        expectedDaysCount={absencesSummary.absenceStats.expected_q1}
        third={1}
      />
      <AbsenceSummaryBlock
        takenDaysCount={absencesSummary.absenceStats.q2q3}
        expectedDaysCount={absencesSummary.absenceStats.expected_q2q3}
        third={2}
      />
      <AbsenceSummaryBlock
        takenDaysCount={absencesSummary.absenceStats.q4}
        expectedDaysCount={absencesSummary.absenceStats.expected_q4}
        third={3}
      />

    </div>
  );
};

AbsencesSummary.propTypes = {
  absencesSummary: PropTypes.shape({
    intraApprovedHolidays: PropTypes.number.isRequired,
    intraYearlyHolidays: PropTypes.number.isRequired,
    absenceStats: PropTypes.shape({
      expected_q1: PropTypes.number.isRequired,
      q1: PropTypes.number.isRequired,
      expected_q2q3: PropTypes.number.isRequired,
      q2q3: PropTypes.number.isRequired,
      expected_q4: PropTypes.number.isRequired,
      q4: PropTypes.number.isRequired,
    }),
  }).isRequired,
};
